// The old ERP backend returns dates as "16-Mar-2027" (DD-Mon-YYYY), not ISO.
// `new Date("16-Mar-2027")` is NOT parsed as UTC the way a pure ISO date
// string is — V8 treats it as local time, then converting via .toISOString()
// shifts it into the previous UTC day for any timezone ahead of UTC
// (confirmed live 2026-08-20 in Asia/Calcutta, UTC+5:30: every batch/course
// date rendered one day earlier than the real value — e.g. "14-Nov-2025"
// became "2025-11-13"). Since this app's real userbase is in India, this bug
// was live for every visitor. Parse the day/month/year numerically instead
// of going through Date() at all, so there's no timezone conversion to get
// wrong. batchService.ts and courseService.ts both had their own
// independently-guessed copy of this parsing — centralized here so there's
// one correct implementation instead of two that can drift.
const MONTHS: Record<string, string> = {
  jan: "01", feb: "02", mar: "03", apr: "04", may: "05", jun: "06",
  jul: "07", aug: "08", sep: "09", oct: "10", nov: "11", dec: "12",
};

/** "16-Mar-2027" (or already-ISO "2027-03-16...") -> "2027-03-16". Returns the input unchanged if it doesn't match either shape. */
export function normalizeOldAppDate(d: string): string {
  if (!d) return "";
  if (/^\d{4}-\d{2}-\d{2}/.test(d)) return d.slice(0, 10);

  const m = d.trim().match(/^(\d{1,2})-([A-Za-z]{3})-(\d{4})$/);
  if (m) {
    const [, day, mon, year] = m;
    const month = MONTHS[mon.toLowerCase()];
    if (month) return `${year}-${month}-${day.padStart(2, "0")}`;
  }
  return d;
}

/** Millisecond timestamp for sorting/comparison — safe for any already-normalized or DD-Mon-YYYY input. Infinity for unparseable input, so it sorts last. */
export function oldAppDateToTimestamp(d: string): number {
  const iso = normalizeOldAppDate(d);
  const t = new Date(iso).getTime();
  return isNaN(t) ? Infinity : t;
}
